/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const ConfirmIncidentRecordFile = zod.object({
  "incidentRecordId": zod.string().uuid().optional(),
  "id": zod.string().uuid().optional()
});

export type ConfirmIncidentRecordFile = zod.input<typeof ConfirmIncidentRecordFile>;
export type ConfirmIncidentRecordFileOutput = zod.output<typeof ConfirmIncidentRecordFile>;
